// src/ConnectionStatus.js

import React, { useState, useEffect } from 'react';

const onlineImage = `${process.env.PUBLIC_URL}/online.png`;
const offlineImage = `${process.env.PUBLIC_URL}/offline.png`;


const ConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={isOnline ? onlineImage : offlineImage}
        alt={isOnline ? 'Online' : 'Offline'}
        style={{ width: '40px', height: '40px', marginRight: '10px' }}
      />
      <p style={{ color: isOnline ? 'green' : 'red', margin: 0 }}>
        {isOnline ? 'You are Online' : 'You are Offline'}
      </p>
    </div>
  );
};

export default ConnectionStatus;
